<div class="space-y-6 rounded-lg border border-greyscale-200 bg-white p-4">
  <!-- Header -->
  <div>
    <h2 class="text-heading-4 font-semibold text-primary-900">
      {{ "objectives.risksTitle" | transloco }}
    </h2>
    <p class="mt-1 text-paragraph-s-reg text-greyscale-600">
      {{ "objectives.risksDescription" | transloco }}
    </p>
  </div>

  <!-- Risk cards grid -->
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
    @for (risk of sortedRisks(); track risk.id) {
      <button
        type="button"
        (click)="toggleRisk(risk.id)"
        [attr.aria-pressed]="isSelected(risk.id)"
        class="group relative flex gap-3 rounded-lg border bg-greyscale-50 p-4 text-left transition-colors"
        [class.border-primary-400]="isSelected(risk.id)"
        [class.ring-2]="isSelected(risk.id)"
        [class.ring-primary-300]="isSelected(risk.id)"
        [class.border-greyscale-200]="!isSelected(risk.id)"
      >
        <span class="absolute right-2 top-2 flex h-5 w-5 items-center justify-center">
          @if (isSelected(risk.id)) {
            <lucide-angular [img]="Pin" class="h-4 w-4 fill-current text-primary-500" />
          } @else {
            <lucide-angular
              [img]="Pin"
              class="h-4 w-4 text-greyscale-300 transition-colors group-hover:text-greyscale-500"
            />
          }
        </span>
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-200">
          <lucide-angular [img]="risk.icon" class="h-5 w-5 text-primary-500" />
        </div>
        <div class="pr-5">
          <h3 class="text-paragraph-s-reg font-semibold text-primary-900">
            {{ risk.titleKey | transloco }}
          </h3>
          <p class="mt-1 text-paragraph-xs-reg leading-relaxed text-greyscale-600">
            {{ risk.descriptionKey | transloco }}
          </p>
        </div>
      </button>
    }
  </div>
</div>
